import request from '@/api/request'
import api from '@/api/api'
import config from '@/api/config'
export const GetOpenMealUrl = (params) => {
    return request.get(config.gateway + api.GetOpenMealUrl, {params: params})
}


// WEBPACK FOOTER //
// ./src/api/mealQuery.js